/**
 * Modal Header Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Modal Header
 */
class ModalHeader extends Component {
    static propTypes = {
        children: childrenPropType,
    };

    static defaultProps = {
        children: null,
    };

    /**
     * Render modal header.
     *
     * @returns {React.node}
     */
    render() {
        const { children } = this.props;

        return (
            <div className="modal-header">
                {children}
            </div>
        );
    }
}

export default ModalHeader;
